import { breakpoints } from '../utils/breakpoints';

const handleShowMore = () => {
  const selectors = {
    item: '.js-hidden-item',
    text: '.js-hidden-text',
    inner: '.js-hidden-inner',
    trigger: '.js-text-trigger',
  };

  const state = {
    active: 'is-active',
  };

  if (window.innerWidth > breakpoints['tablet-lg']) return;

  const elems = [...document.querySelectorAll(selectors.item)];

  elems.forEach((elem) => {
    const hiddenTextInner = elem.querySelector(selectors.inner);
    const hiddenText = elem.querySelector(selectors.text);
    const showMoreBtn = elem.querySelector(selectors.trigger);

    hiddenTextInner.style.height = 100 + 'px';

    showMoreBtn.addEventListener('click', () => {
      if (hiddenTextInner.offsetHeight === hiddenText.offsetHeight) {
        hiddenTextInner.style.height = 100 + 'px';
      } else {
        hiddenTextInner.style.height = hiddenText.offsetHeight + 'px';
      }
      showMoreBtn.classList.toggle(state.active);
    });
  });
};

export default handleShowMore;
